import * as React from 'react';
import * as moment from 'moment';

import { connect } from 'react-redux';

import ListProductionView from '../../views/library/list-production.view';
import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IProduction, IPerformance } from '../../custom/classes/production';

interface IListProductionExternalProps {
    production: IProduction;
}

interface StateToProps {
    text: IPackageListingAppText;
    filterFunction: (option) => any;
    performancesInCart: Array<number>;
    isFixed: boolean;
}

interface ListProductionViewState {
    showPerformances: boolean;
    showSynopsis: boolean;
}

interface ViewProps {
    toggleShowPerformances: () => void;
    toggleShowSynopsis: () => void;
    filteredPerformances: Array<IPerformance>;
    showProductionAddedToCart: boolean;
    themeClass: string;
}

export type ListProductionProps = IListProductionExternalProps & StateToProps;

export type CombinedProductionViewProps = ListProductionProps & ListProductionViewState & ViewProps;

export class ListProductionBase extends React.Component<ListProductionProps, ListProductionViewState> {

    constructor(props: ListProductionProps) {
        super(props);

        this.state = {
            showPerformances: false,
            showSynopsis: false
        };
    }
    render() {



        const filteredPerformances = this.props.production.performances.filter(this.props.filterFunction);

        if (filteredPerformances.length == 0)
            return null;

        const themeClass = this.props.isFixed ? "" : "block-" + this.props.production.theme;
        const performanceIds = filteredPerformances.map(p => p.performanceId);
        const cartHasPerformance = performanceIds.filter(id => this.props.performancesInCart.indexOf(id) >= 0).length > 0;

        return (
            <ListProductionView {...this.props} {...this.state}
                filteredPerformances={filteredPerformances}
                toggleShowPerformances={this._toggleShowPerformances.bind(this)}
                toggleShowSynopsis={this._toggleShowSynopsis.bind(this)}
                showProductionAddedToCart={cartHasPerformance}
                themeClass={themeClass}
            />
        )
    }

    _toggleShowPerformances = () => {
        this.setState(
            { showPerformances: !(this.state.showPerformances) }
        );
    }

    _toggleShowSynopsis = () => {
        this.setState(
            { showSynopsis: !(this.state.showSynopsis) }
        );
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListProductionExternalProps): StateToProps {
    return {
        text: state.packageListingText,
        filterFunction: state.packageListing.filterFunction,
        performancesInCart: Array.from(state.packageListing.cartItems.keys()),
        isFixed: state.packageListingSettings.isFixed
    }
}


export default connect<StateToProps>(mapStateToProps)(ListProductionBase);

